import { Box, Modal } from '@mui/material'
import { DBServer, Tag } from '../../../types/types'
import { useEffect, useRef, useState } from 'react'
import { Button } from 'react-bootstrap'

export interface ServerEditModalProps {
  field: DBServer | undefined
  open: boolean
  cancel: Function
  submit: Function
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  maxWidth: '75%',
  minWidth: '35%',
  height: 'auto',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  overflow: 'hidden',
  p: 4,
}

function ServerEditModal(props: ServerEditModalProps) {
  const formRef = useRef(null)
  const [name, setName] = useState('')
  const [connection, setConnection] = useState('')
  const [user, setUser] = useState('')
  const [password, setPassword] = useState('')
  const [holdsDemo, setHoldsDemo] = useState(false)

  useEffect(() => {
    if (!props.open) {
      return
    }

    setPassword('')

    if (!props.field) {
      setName('')
      setUser('')
      setConnection('')
      setHoldsDemo(false)
      return
    }

    setName(props.field.name)
    setConnection(props.field.connection)
    setUser(props.field.username)
    setHoldsDemo(props.field.holds_demo)
  }, [props.open])

  const onSubmit = (event: any) => {
    event.preventDefault()
    props.submit(name, connection, user, password, holdsDemo)
  }

  return (
    <div>
      <Modal
        open={props.open}
        onClose={() => {
          props.cancel()
        }}
      >
        <Box sx={style}>
          <div>
            <form ref={formRef} onSubmit={onSubmit}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '15px',
                }}
              >
                <div className="textFieldDiv">
                  <label>Name</label>
                  <input
                    type="text"
                    placeholder="Name"
                    value={name}
                    required={true}
                    onChange={(e) => {
                      setName(e.target.value)
                    }}
                  />
                </div>
                <div className="textFieldDiv">
                  <label>Connection</label>
                  <input
                    type="text"
                    placeholder="Connection"
                    value={connection}
                    required={true}
                    onChange={(e) => {
                      setConnection(e.target.value)
                    }}
                  />
                </div>
                <div className="textFieldDiv">
                  <label>Username</label>
                  <input
                    type="text"
                    placeholder="Username"
                    value={user}
                    required={true}
                    onChange={(e) => {
                      setUser(e.target.value)
                    }}
                  />
                </div>
                <div className="textFieldDiv fullWidth">
                  <label>Password</label>
                  <input
                    type="password"
                    placeholder="Passowrd"
                    value={password}
                    required={props.field === undefined}
                    onChange={(e) => {
                      setPassword(e.target.value)
                    }}
                  />
                  {props.field && (
                    <label className="smallFont">
                      Leave empty if unchanged
                    </label>
                  )}
                </div>
                <div className='textFieldDiv fullWidth'>
                  <label>Can hold Demo Tenants?</label>
                  <input
                    type="checkbox"
                    placeholder="holdsDemo?"
                    checked={holdsDemo}
                    required={false}
                    onChange={(e) => {
                      setHoldsDemo(e.target.checked)
                    }}
                  />
                </div>
                <div>
                  <Button type="submit">Save</Button>
                </div>
              </div>
            </form>
          </div>
        </Box>
      </Modal>
    </div>
  )
}

export default ServerEditModal
